module.exports = __webpack_public_path__ + "static/media/grocery-product-6.b175f431.png";